import React, { useEffect } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import './Editor.scss';
import { formInputFieldName } from '../form/form-input-constants';

interface IEditor {
    formik: any;
    editorPlaceholder?: string;
    fieldName: formInputFieldName;
    fieldLabel?: any;
    value: string;
    showLink?: boolean;
}

export const Editor = (props: IEditor): JSX.Element => {
    const { formik, editorPlaceholder, fieldName, fieldLabel, value, showLink } = props;


    const modules = {
        toolbar: showLink ? [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'link'],
            [{ list: 'ordered' }, { list: 'bullet' }]
        ] : [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }]
        ],
    };

    const placeholder = editorPlaceholder;

    const formats = ['bold', 'italic', 'underline', 'strike', 'list', 'link'];

    const { quill, quillRef } = useQuill({ modules, formats, placeholder });

    useEffect(() => {
        if (quill) {
            quill.root.innerHTML = `${value}`;
            quill.on('text-change', () => {
                formik.setFieldValue(fieldName, quill.root.innerHTML);
            });
        }
    }, [quill]);

    return (
        <div className="mb-5">
            {fieldLabel && (
                <label className="form-label col-12">
                    {fieldLabel}
                </label>
            )}
            <div ref={quillRef} />
        </div>
    );
};
